if (!global._babelPolyfill) {
    require('babel-polyfill')
};

import React from "react";
import { connect } from "react-redux";

import * as actionTypes from "../actions/actionTypes";
let actions = require("../actions/actions");

export class SaveForLaterModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showNote: false
        };
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.result.actionType ===
            actionTypes.SAVE_UPLOAD_FOR_LATER_SUCCESS
        ) {
            this.props.fetchUploadIcons("");
            this.props.dismissModal();
        }
    }

    dismissModal(e) {
        if (e) e.preventDefault();

        this.props.dismissModal();
    }

    render() {
        let notesSection;

        if (this.state.showNote) {
            notesSection = (
                <span>
                    <textarea
                        placeholder="Write something here..."
                        ref="creatorNote"
                        defaultValue={this.props.upload.creator.notes}
                    />
                    <a
                        className="text-link"
                        onClick={this.showHideNote.bind(this)}
                    >
                        {"Cancel"}
                    </a>
                </span>
            );
        } else {
            notesSection = (
                <span>
                    <a
                        href="#"
                        className="ui_plus"
                        title={"Add a note"}
                        onClick={this.showHideNote.bind(this)}
                    >
                        {"Add a note"}
                    </a>
                </span>
            );
        }

        return (
            <div
                className={
                    "react-modal full-transparent moderation-modal-background save-for-later-modal"
                }
            >
                <a
                    href="#"
                    className="modal-background-closer"
                    onClick={this.dismissModal.bind(this)}
                />
                <div className={"inner-modal"}>
                    <a
                        href="#"
                        onClick={this.dismissModal.bind(this)}
                        title="close"
                        className="ui_close"
                    />
                    <div className="modal-content">
                        <div className="save-for-later-clock ui_clock purple" />
                        <h3 className="modal-title">
                            {"Do you want to save this Creator for later?"}
                        </h3>
                        <button
                            className="btn btn-default purple"
                            onClick={this.saveForLater.bind(this)}
                        >
                            {"Yes, I want to review them later"}
                        </button>
                        <div className="cancel-btn">
                            <a
                                className="text-link"
                                onClick={this.dismissModal.bind(this)}
                            >
                                {"Nevermind, I'll review them now"}
                            </a>
                        </div>
                        <div className="notes-section gray">
                            {notesSection}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    saveCreatorNote() {
        let creator = Object.assign({}, this.props.upload.creator),
            note = this.refs["creatorNote"];

        if (note) {
            creator.note = note.value;
            this.props.saveCreatorNote(creator);
        }
    }

    saveForLater() {
        if (this.refs["creatorNote"]) {
            this.saveCreatorNote();
        }
        this.props.saveBatchForLater(this.props.upload.id);
    }

    showHideNote(e) {
        e.preventDefault();

        switch (this.state.showNote) {
            case true:
                this.setState({ showNote: false });
                break;
            case false:
                this.setState({ showNote: true });
                break;

        }
    }
}

export default connect(null, {
    fetchUploadIcons: actions.fetchUploadIcons,
    saveCreatorNote: actions.saveCreatorNote,
    saveBatchForLater: actions.saveBatchForLater
})(SaveForLaterModal);
